import { request } from './dashboardApi';

export const reminderService = {
  // 1. Fetch reminder list and summaries
  getReminderList: async () => {
    return request('/reminder/list');
  },

  // 2. Set or update reminder date and time for a single customer
  setReminderDate: async (payload) => {
    return request('/reminder/set-date', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  // 3. Set or update reminder date for multiple customers in bulk
  bulkSetReminderDate: async (payload) => {
    return request('/reminder/bulk-set-date', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  // 4. Bulk send WhatsApp reminders via official cloud API
  bulkSendWhatsApp: async (customerIds) => {
    return request('/reminder/bulk-send-whatsapp', {
      method: 'POST',
      body: JSON.stringify({ customer_ids: customerIds }),
    });
  },

  // 5. Mark reminder as sent (logs timestamp)
  markReminderSent: async (customerId) => {
    return request('/reminder/mark-sent', {
      method: 'POST',
      body: JSON.stringify({ customer_id: customerId }),
    });
  },
};

export default reminderService;
